import React from 'react'
import config from '../config.json'

const MovieTimesPeriodeDaysItemAttributes = ({attributes, theatreName, hideTheatres, accentColorDark, iconsColor = 'dark'}) => {
    if(!attributes) {
        return ''
    }
    
    let style 

    const hexToR = (h) => {return parseInt((cutHex(h)).substring(0,2),16)}
    const hexToG = (h) => {return parseInt((cutHex(h)).substring(2,4),16)}
    const hexToB = (h) => {return parseInt((cutHex(h)).substring(4,6),16)}
    const cutHex = (h) => {return (h.charAt(0)=="#") ? h.substring(1,7):h}
    
    const backgroundColor = hexToR(accentColorDark) + ',' + hexToG(accentColorDark) + ',' + hexToB(accentColorDark)
    
    const allAtributes = attributes.map((attribute, index) => {
        const {name} = attribute 
        const id = String(attribute.id)

        if(id === '1088' || id === '3d') {
            style = {
                backgroundColor: 'rgba(' + backgroundColor + ', 0.26)'
            }
        }
    
        const logoClass = _.contains(config.attributesWithIcons, id) ? 'attribute-logo ' + iconsColor + '-attribute': ''
        const doNotDisplayTitle = _.contains(config.attributesWithIcons, id) ? 'screen-reader-text' : ''
        
        return (
            <span className={logoClass} data-attribute={id} key={index}>
                <span className={doNotDisplayTitle + ' ' + 'text-medium'}>{name}</span>
            </span>
        )
    })
    
    if(!attributes) {
        return
    } else {
        return (
            <div className="performance-attributes">
                {(hideTheatres === 'false' || !hideTheatres) && <span className="text-light-grey theatre-name">{theatreName}</span>}
                {allAtributes}
            </div>
        )             
    }
}

export default MovieTimesPeriodeDaysItemAttributes